/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 *
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.3.1
 * @since 1.1.0
 */

import styled from 'styled-components';

import { colors } from '../../../../../theme';

export const WidgetDateRangeStyled = styled.div.attrs({
    className: 'widget__date-range',
})`
    color: ${colors.pageDashboardWidgetSecondaryText};
`;
